import { render } from "./NossosCultos.vue?vue&type=template&id=19b44299&scoped=true&lang=pug"
import script from "./NossosCultos.vue?vue&type=script&setup=true&lang=js"
export * from "./NossosCultos.vue?vue&type=script&setup=true&lang=js"

import "./NossosCultos.vue?vue&type=style&index=0&id=19b44299&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b44299"]])

export default __exports__